<mat-toolbar class="main-header justify-content-between">
  <img src="../../../../assets/images/bna-logo-text.png" height="40" class="bna-logo-dark" style="padding: 5px" />
  <img src="../../../../assets/images/bna-logo-text.png" height="40" class="bna-logo-white" style="padding: 5px; display: none;" />
  <div class="d-flex align-items-center">
    <button *ngIf="!hideJobPostOnInspectionManager" class="btn btn-primary btn-round bw" mat-button routerLink="/job/job-post"
      [appTargetId]="'Job post button'"> + Job post </button>

      <div *ngIf="isAssetRecommendationEnabled" class="notifications me-3 ms-4 cursor-pointer" (click)="showRecommendations()"
          matTooltip='Smart Recommendations'
          matTooltipClass="smart-recommendation-tooltip"
          matTooltipPosition="below">
        <img src="../../../../assets/images/maintenance.png"/>
        <div *ngIf="(recommendationCount !== 0 && recommendationCount != null && recommendationCount < 100)"
          class="count">{{recommendationCount}}</div>
        <div *ngIf="(recommendationCount !== 0 && recommendationCount != null && recommendationCount > 99)"
          class="count">99+</div> 
      </div>

    <div class="notifications me-3 ms-4 cursor-pointer" (click)="showEmailNotifications()">
      <mat-icon class="material-icons-outlined float-start" mat-list-icon>email</mat-icon>
      <div *ngIf="(emailNotificationCount !== 0 && emailNotificationCount != null && emailNotificationCount < 100)"
        class="count">{{emailNotificationCount}}</div>
      <div *ngIf="(emailNotificationCount !== 0 && emailNotificationCount != null && emailNotificationCount > 99)"
        class="count">99+</div>
    </div>

    <app-user-profile-menu></app-user-profile-menu>
  </div>
</mat-toolbar>

<mat-drawer-container [hasBackdrop]="true" class="custom-drawer smart-recommendation-drawer">
  <mat-drawer class="lg" mode="over" position="end" [(opened)]="isOpenRecommendationDrawer" *ngIf="isOpenRecommendationDrawer">
    <app-asset-recommendations (closeEvent)="closeRecommendationDrawer()">
    </app-asset-recommendations>
  </mat-drawer>
</mat-drawer-container>


<mat-drawer-container [hasBackdrop]="true" class="custom-drawer">
  <mat-drawer class="lg" mode="over" position="end" [(opened)]="isOpenEmailDrawer" *ngIf="isOpenEmailDrawer">
    <app-email-notifications [organizationPmUserIds]="organizationPmUserIds" (closeEvent)="closeDrawer()">
    </app-email-notifications>
  </mat-drawer>
</mat-drawer-container>